import { appConfig } from 'brand-config';

/**
 * Whether this brand shows the staff invoice history on the Customer page (#36679). On for the mutual
 * brands (CFM / Forreston / Oakwood), off for Branch. Read from the build-time brand config; the section
 * is additionally limited to internal staff. Mirrors isSendInvoiceAllowed.
 */
export const isInvoiceHistoryAllowed = () => Boolean(appConfig?.featureFlags?.invoiceHistory);
